module.exports = __webpack_public_path__ + "static/media/MBJ_Collaboration_NARUTO_LOGO_White.e122eec5.svg";